/**
 * Determines the appropriate gradient style based on the card type and status.
 *
 * @param {boolean} isCreditCard - Indicates if the card is a credit card.
 * @param {boolean} isExpired - Indicates if the card is expired.
 * @param {boolean} isDisabled - Indicates if the card is disabled.
 * @returns {string} - The CSS class name representing the gradient style.
 */
export const gradientStyle = (
  isCreditCard: boolean,
  isExpired: boolean,
  isDisabled: boolean
): string => {
  const disabledStyle =
    'co-bg-pds-neutral-200 co-select-none co-cursor-pointer';
  if (isDisabled) return disabledStyle;

  const expiredStyle = 'co-bg-pds-neutral-200';
  if (isExpired) return expiredStyle;

  const creditStyle = 'co-bg-saved-creditCard';
  const debitStyle = 'co-bg-saved-debitCard';
  const gradientConf = isCreditCard ? creditStyle : debitStyle;
  return gradientConf;
};
